import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import './index.css';
import App from './App';
import { getApiOrigin } from './utils/apiBase';

const apiOrigin = getApiOrigin() || window.location.origin;
axios.defaults.baseURL = apiOrigin;
window.__RTC_API_ORIGIN = apiOrigin;

// Suppress the noisy (and usually harmless) ResizeObserver loop error that can be triggered
// by complex layouts (e.g., video grids) in Chrome. CRA dev overlay treats it as a runtime error.
// We only ignore this specific message.
const __resizeObserverErr = /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/i;
window.addEventListener('error', (e) => {
  if (__resizeObserverErr.test(e?.message || '')) {
    e.stopImmediatePropagation();
  }
});

// Prevent mouse wheel from incrementing/decrementing focused number inputs (e.g. price fields).
document.addEventListener(
  'wheel',
  (e) => {
    const el = document.activeElement;
    if (el?.tagName === 'INPUT' && el.type === 'number') {
      e.preventDefault();
    }
  },
  { passive: false }
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

